<!-- outer node -->
<ng-container *ngIf="viewLocation === 'create-project'">
  <button id="expandCollapse" title="Collapse" class="btn btn-clear px-2 py-0 mb-2"
    (click)="updateExpandCollapseButton();">
    <em class="material-icons-outlined font-4x" aria-hidden="true">
      close_fullscreen
    </em>Collapse</button>
</ng-container>

<ng-template #branch let-treeNodes>
  <div *ngFor="let item of treeNodes;let index= index">
    <ng-container *ngTemplateOutlet="leaf; context: {item: item,siblings: treeNodes, index: index+1}"></ng-container>
  </div>
</ng-template>

<!-- leaf node -->
<ng-template let-item="item" let-siblings="siblings" let-index="index" #leaf>
  <div class="table-view" *ngIf="isFilterApplied ? item.isSearchResult : true"
    [ngClass]="viewLocation === TAXONOMY_BUILDER?'tree-builder':'table-tree'">
    <div class="card" [class.shifted]="item.reorder === 1" [class.pasted]="item.paste===1 && inprogressStatus ===2" role="table"
      [ngClass]="viewLocation === TAXONOMY_BUILDER?'':'border-0'">
      <div class="card-header" id="headingOne_{{item.id}}"
        *ngIf="isConfigured ? (item['level'] >= firstNodeLevel) : true"
        [ngClass]="[item.children?.length===0?'last-child-node':'', item.id===selectedNodeId && viewLocation === TAXONOMY_BUILDER? 'activated':'']">
        <div class="tbody" role="rowgroup">
          <div class="row mx-0 tr justify-content-between" role="row"
            [ngClass]="[selectedNodeId === item.id && copyPasteFlag===0 ? 'active':'', copyPasteFlag===1 && (reOrder && item.cut===1) ? 'cut':'',
            (viewLocation === PUBLIC_REVIEW_LOCATION && (item.hasComment === undefined) && (allCommented===false)) ? 'cursor-deny dim':'',viewLocation === 'create-project'?'pl-5':'']"
            [class.dim]="isConfigured ? checkLevelConfig(item.level) : (isAllNode===false ? '':
            (viewLocation === PROJECT_AUTH_LOCATION && item.project_enabled == 0) || (viewLocation === TAXONOMY_BUILDER && modalTriggerLocation ==='project' && item.project_enabled == 0))">
            <div role="cell" class="w-100 d-flex justify-content-between align-items-start"
              [style.padding-left]="calculatePadding(item.level)">
              <div class="d-flex justify-content-start align-items-start p-0 indv-node"
                [ngClass]="[viewLocation === PROJECT_AUTH_LOCATION? (reOrder?'col':'col'):(viewLocation === CUSTOM_VIEW_LOCATION) || (viewLocation === TAXONOMY_BUILDER)?'col-lg-12 col-xl-12 py-1':'col']">

                <button
                    *ngIf="showExpandBtn(item)"
                    class="btn btn-toggle"
                    [ngClass]="[item.expand?'':'collapsed']"
                    id="{{ item.id }}-atag"
                    [disabled] = "item.paste && item.paste ===1"
                    (click)="item.expand = !item.expand"
                    [attr.aria-label]=
                        "('click to '
                        + (item.expand ? 'collapse ' : 'expand ')
                        + 'node- '
                        + item?.human_coding_scheme
                        + ' '
                        + item?.full_statement
                        + item?.document_title)">
                </button>
                <span *ngIf="showBullet(item)" [ngClass]="[item.expand?'':'collapsed', showBullet(item)?'last-node':'']"
                  class="float-left pl-0" id="{{ item.id }}-atag">
                </span>
                <button *ngIf="viewLocation !== TAXONOMY_BUILDER && !item.isOrphanLabel" class="btn btn-node w-95 p-0"
                  id="{{item.id}}-{{'node'}}" [attr.aria-pressed]="selectedNodeId === item.id && copyPasteFlag===0"
                  (click)="onNodeSelected(item);selectedNodeId = item.id"
                  [ngStyle]="calculateStyle(item?.custom_view_data)"
                  [disabled] = "item.paste && item.paste ===1"
                  [ngClass]="{'full-width-node': viewLocation === CUSTOM_VIEW_LOCATION, 'mark':item.isHighlighted}"
                  [attr.aria-label]="'node- ' + item?.human_coding_scheme + ' ' + item?.full_statement + ((selectedNodeId === item.id && copyPasteFlag===0) ? '': ', click to get node details')">
                  <span id="{{ item.id }}_html-content">
                    <ng-container *ngIf="viewLocation === CUSTOM_VIEW_LOCATION">
                      <span class="pr-1 d-inline">{{getCustomViewTitle(item?.custom_view_data)}}</span>
                    </ng-container>
                    <ng-container
                      *ngIf="viewLocation !== CUSTOM_VIEW_LOCATION && viewLocation !== TAXONOMY_BUILDER && viewLocation !== 'create-project'">
                      <span class="pr-1 d-inline">{{item.human_coding_scheme | slice:0:charLimit}}</span>
                      <span [mathJax]="item.full_statement" class="tree-long-field d-inline">
                      </span>
                  
                      <span class="mb-0 mx-3" *ngIf="item.paste && inprogressStatus ===2">&nbsp; Copying...
                      </span>
                      <button class="btn btn-icon tooltip right position-relative" id="externalassociationBtn"
                        [attr.aria-label]="'External Association'" data-tooltip="External Association"
                        *ngIf="item.isAssociationNode && item.association_type !== 'isChildOf'">
                        <em class="material-icons-outlined font-2x" aria-hidden="true">error_outline</em>
                      </button>
                    </ng-container>
                  </span>
                </button>
                <p class="font-bold font-3x mb-0" id="{{item.id}}-{{'node'}}" *ngIf="item.isOrphanLabel">
                  {{item.human_coding_scheme | slice:0:charLimit}}
                  {{item.full_statement}}
                </p>

                <div *ngIf="viewLocation === TAXONOMY_BUILDER && !item.isOrphanLabel" id="{{item.id}}-{{'node'}}"
                  class="node-text w-100" (click)="onNodeSelected(item);selectedNodeId = item.id">
                  <ng-container>
                    <p class="mb-0">
                      <!-- UF-45813 onPaste event removed -->
                      <span
                        contenteditable="true"
                        *ngIf="item.parent || item.is_document"
                        (blur)="blurDocumentTitle(item,$event);"
                        (keyup)="onKeyUp($event);"
                        (keypress)="onKeyPress(item,$event,'document');"
                        (focus)="onFocus(item);onNodeSelected(item)"
                        aria-multiline="false"
                        role="textbox"
                        aria-label="Document title"
                        tabindex="0">
                        {{item.document_title
                          ? extractContentFromHtml(item.document_title)
                          : extractContentFromHtml(item.title)
                        }}
                      </span>
                      <!-- Formatting could not be done for the curly braces syntax as
                            aria label is not printing if there is a space in the labels -->
                      <span
                        contenteditable="true"
                        class="human-code"
                        id="{{ item.id }}-span"
                        *ngIf="!item.parent && !item.is_document"
                        (blur)="blurHumanCodingScheme(item,$event);"
                        (keyup)="onKeyUp($event);"
                        (keypress)="onKeyPress(item,$event,'humanCodeScheme');"
                        (focus)="onFocus(item);onNodeSelected(item)"
                        aria-multiline="false"
                        role="textbox"
                        aria-label="Human coding scheme"
                        tabindex="0">{{extractContentFromHtml(item.human_coding_scheme)}}</span>
                      <span
                        *ngIf="!item.parent"
                        aria-hidden="true"
                        class="float-left px-2">:
                      </span>
                      <!-- Formatting could not be done for the curly braces syntax as
                            aria label is not printing if there is a space in the labels -->
                      <span
                        contenteditable="true"
                        class="full-statement"
                        *ngIf="!item.parent && !item.is_document"
                        (blur)="blurFullStatement(item,$event);"
                        (keyup)="onKeyUp($event);"
                        (keypress)="onKeyPress(item,$event,'fullStatement');"
                        (focus)="onFocus(item);onNodeSelected(item)"
                        aria-multiline="false"
                        aria-required="true"
                        role="textbox"
                        aria-label="statement"
                        tabindex="0">{{extractContentFromHtml(item.full_statement)}}</span>
                      <span class="controls">
                        <button class="btn btn-icon tooltip top lg position-relative d-inline-block"
                          data-tooltip="Add new node" id="{{ item.id }}-add"
                          *ngIf="isAddNode && (item.level!==levelLimit || levelLimit===-1 || levelLimit > item.level) && (modalTriggerLocation ==='project' ? item.project_enabled !== 0 : true)"
                          (click)="addNode(item)" [attr.aria-label]="'Add new node'">
                          <em class="material-icons-outlined button-icon font-3x" aria-hidden="true">add</em>
                        </button>
                        <app-preloader
                          *ngIf="showLoader"
                          [loaderText]="'Adding Node...'"
                          class="w-100 h-100 position-fixed preloader-backdrop">
                        </app-preloader>
                        <button class="btn btn-icon tooltip top lg position-relative d-inline-block"
                          data-tooltip="Delete node" id="{{ item.id }}-delete"
                          *ngIf="isDeleteNode && !item.parent && (modalTriggerLocation === 'project' ? item.project_enabled !== 0 : true)"
                          (click)="deleteNode(item, siblings)" [attr.aria-label]="'Delete node'"><em
                            class="material-icons-outlined button-icon font-3x" aria-hidden="true">delete</em></button>
                      </span>

                      <span class="float-right p-0 text-right auto-complete-container"
                        *ngIf="viewLocation =='taxonomy_builder'">
                        <span class="template_tiltle" *ngIf="item.template_tiltle">{{ item.template_tiltle }}</span>
                        <span class="template_tiltle"
                          *ngIf="(item.parent || item.is_document) && !item.template_tiltle">Document</span>
                        <div class="dropdown" *ngIf="!item.template_tiltle && (!item.parent && !item.is_document)">
                          <app-auto-complete [listingObj]="item.nodetypeList"
                            (selectedObject)="selectMetaData($event, item)" [selectType]="'single'" [canDelete]="false"
                            [uniqueId]="'node_type_id'" [propName]="'title'" [index]="item.id" [treeView]="true"
                            [defaultSelection]="item.metadataType? getDefaultSelection(item.metadataType) : null"
                            [autoCompleteTitle]="autoCompleteTitle" [isMandatory]="false" [isLableShow]="false"
                            #autoCompleteNodetype>
                          </app-auto-complete>
                        </div>

                      </span>
                    </p>
                  </ng-container>
                </div>
              </div>
              <div class="d-flex align-items-center" *ngIf="viewLocation !== CUSTOM_VIEW_LOCATION && viewLocation !== TAXONOMY_BUILDER">

                <!-- API has been commented off for the project tree image, future when it will be used needs to update the material icon -->
                <span *ngIf="!item.isCommented && showNoComment && allCommented && item.is_document === 0"
                class="tooltip top top-right position-relative d-inline-block"
                [attr.aria-label]="'Node has issue'" data-tooltip="Node has issue">
                <img src="assets/images/ic_warning.png" alt="Node has issue" class="img-fluid ic-edit" />
              </span>

              <span *ngIf="item.isCommented" class="tooltip top top-right position-relative"
                [attr.aria-label]="'Node has comment'" data-tooltip="Node has comment">
                <em class="material-icons-outlined font-2x" aria-hidden="true">chat_bubble_outline</em>
              </span>

              <!-- API has been commented off for the project tree image, future when it will be used needs to update the material icon -->
              <ng-container *ngIf="reOrder && !item.isOrphanLabel">
                  <button class="btn btn-icon tooltip top top-right position-relative d-inline-block"
                    id="pastenodeBtn" [attr.aria-label]="'Paste node'" data-tooltip="Paste node"
                    *ngIf="(copyPasteFlag===1 && selectedNodeId !== item.id && item.cut===0) && (isAllNode===true && item.project_enabled == 1) && levelLimit===-1"
                    (click)="copyPasteFlag = 0;pasteTargetElement(item,siblings);">
                    <em class="material-icons-outlined font-4x" aria-hidden="true">content_paste</em> </button>
                  <button class="btn btn-icon tooltip top top-right position-relative d-inline-block"
                    id="pastenodeBtn" [attr.aria-label]="'Paste node'" data-tooltip="Paste node"
                    *ngIf="(copyPasteFlag===1 && selectedNodeId !== item.id && item.cut===0) && (isAllNode===true && item.project_enabled == 1) && levelLimit!==-1 && levelLimit > item.level && item.level === (this.sourceElement.level - 1)"
                    (click)="copyPasteFlag = 0;pasteTargetElement(item,siblings);">
                    <em class="material-icons-outlined font-4x" aria-hidden="true">content_paste</em> </button>
                  <ng-container
                    *ngIf="item.is_document !== 1 && (item?.id !== firstNode?.id) && (isAllNode===true && item.project_enabled == 1)">
                    <button class="btn btn-icon tooltip top top-right position-relative d-inline-block"
                      [attr.aria-label]="'Cut node'" data-tooltip="Cut node" *ngIf="copyPasteFlag===0"
                      (click)="copyPasteFlag = 1;selectedNodeId = item.id;copySourceElement(item,siblings);">
                      <em class="material-icons-outlined font-4x" aria-hidden="true">content_cut</em> </button>
                    <button class="btn btn-icon tooltip top top-right position-relative d-inline-block"
                      id="moveupwardBtn" [attr.aria-label]="'Move upward'" data-tooltip="Move upward"
                      (click)="reOrderSiblings(siblings, -1, item.id);"
                      *ngIf="siblings.length !== 1 && index !== 1">
                      <em class="material-icons-outlined font-4x" aria-hidden="true">arrow_upward</em>
                    </button>
                    <button class="btn btn-icon tooltip top top-right position-relative d-inline-block"
                      id="movedownwardBtn" [attr.aria-label]="'Move downward'" data-tooltip="Move downward"
                      (click)="reOrderSiblings(siblings, +1, item.id);"
                      *ngIf="siblings.length !== index && siblings.length !== 1">
                      <em class="material-icons-outlined font-4x" aria-hidden="true">arrow_downward</em>
                    </button>
                  </ng-container>
              </ng-container>
              <ng-container *ngIf="duplicate && !item.isOrphanLabel && !reOrder">
                <button class="btn btn-icon tooltip top top-right position-relative d-inline-block"
                  id="pastenodeBtn" [attr.aria-label]="'Paste node'" data-tooltip="Paste node"
                  data-toggle="modal" data-target="#duplicateSettings"
                  (click)="pasteDuplicateElement(item)"
                  *ngIf="(copyPasteFlag===1 && copiedNodeId !== item.id && item.cut===0) && (isAllNode===true && item.project_enabled == 1) && levelLimit===-1">
                  <em class="material-icons-outlined font-4x" aria-hidden="true">content_paste</em> </button>
                  <button class="btn btn-icon tooltip top top-right position-relative d-inline-block"
                  id="pastenodeBtn" [attr.aria-label]="'Paste node'" data-tooltip="Paste node"
                  data-toggle="modal" data-target="#duplicateSettings"
                  (click)="pasteDuplicateElement(item)"
                  *ngIf="(copyPasteFlag===1 && copiedNodeId !== item.id && item.cut===0) && (isAllNode===true && item.project_enabled == 1) && levelLimit!==-1 && levelLimit > item.level && item.level === (this.sourceElement.level - 1)">
                  <em class="material-icons-outlined font-4x" aria-hidden="true">content_paste</em> </button>
                <ng-container
                  *ngIf="item.is_document !== 1 && (item?.id !== firstNode?.id) && (isAllNode===true && item.project_enabled == 1)">
                  <div class="dropdown" *ngIf="item.children && item.children.length > 0">
                    <button class="btn btn-icon tooltip top top-right position-relative d-inline-block"
                            [attr.aria-label]="'Copy node'" 
                            data-tooltip="Copy node"
                            data-toggle="dropdown"
                            aria-haspopup="true" 
                            aria-expanded="false" 
                            data-reference="parent"
                            *ngIf="copyPasteFlag===0 && !item.paste"
                            >
                    <em class="material-icons-outlined font-4x" aria-hidden="true">content_copy</em> </button>
                    <div id="{{item?.id}}copyDrpDwn" class="dropdown-menu dropdown-menu-left">
                    <button type="button" 
                            class="btn btn-clear dropdown-item"
                            (click)="copyWithChild=0;selectedNodeId = item.id;copiedNodeId= item.id;copyDuplicateElement(item,siblings);"
                      >Copy Node</button>
                      <button 
                        type="button" 
                        class="btn btn-clear dropdown-item"
                        (click)="copyWithChild=1;selectedNodeId = item.id;copiedNodeId= item.id;copyDuplicateElement(item,siblings);"
                      >Copy Node along with child node</button>
                  </div>
                  </div>
                  <button *ngIf="copyPasteFlag===0 && !item.paste && (!item.children || (item.children && item.children.length === 0))" 
                          class="btn btn-icon tooltip top top-right position-relative d-inline-block"
                          [attr.aria-label]="'Copy node'" data-tooltip="Copy node"
                          (click)="selectedNodeId = item.id;copiedNodeId= item.id;copyDuplicateElement(item,siblings);">
                      <em class="material-icons-outlined font-4x" aria-hidden="true">content_copy</em> </button>
                  
                </ng-container>
            </ng-container>
              
                <button type="button" class="btn tooltip top top-right btn-common" id="addNodeBtn"
                  [disabled] = "item.paste && item.paste ===1"
                  data-tooltip="Add node" 
                  [attr.aria-label]="'Add node'" 
                  (click)="addNode(item)" 
                  *ngIf="isAddNode && item.is_editable===1 && (item.level!==levelLimit || levelLimit===-1 || levelLimit > item.level)">
                  <em class="material-icons-outlined font-4x button-icon" aria-hidden="true">add</em>
                </button>
                <div class="more-option dropdown"
                  [ngStyle]="{'display':item.is_document===1 && !isDeleteNode? 'none' : 'block' }" *ngIf="(isDeleteNode || isAddAssociations) && !item.parent && item.is_editable===1 && !preventEdit">
                  <button aria-expanded="false" aria-haspopup="true"
                    class="btn btn-common tooltip top top-right p-0" id="configureBtn"
                    *ngIf="item.is_document!==1"
                    data-tooltip="Configure" [attr.aria-label]="'Configure'" data-reference="parent"
                    data-toggle="dropdown" type="button" [disabled] = "item.paste && item.paste ===1">
                    <em class="material-icons-outlined font-4x button-icon" aria-hidden="true">more_horiz</em>
                  </button>

                  <div class="dropdown-menu dropdown-menu-right" x-placement="bottom-end">
                    <button *ngIf="item.is_document!==1 && isAddAssociations && (item.level!==levelLimit || levelLimit===-1 || levelLimit > item.level)" type="button"
                      class="btn btn-clear dropdown-item" id="taxonomyAssociationBtn" data-toggle="modal"
                      (click)="addAssociation(item)" data-target="#taxonomyAssociation">Add from taxonomy<span
                        class="sr-only">Opens in a new dialog</span>
                    </button>
                    <button *ngIf="isDeleteNode" type="button" class="btn btn-clear dropdown-item" id="delnodeBtn"
                      (click)="deleteNode(item,siblings)" aria-label="Delete node">Delete
                      this node</button>
                  </div>
                </div>  
                
            </div>
            </div>
          </div>
        </div>
      </div>

      <div id="{{item.id}}" [attr.aria-labelledby]="'headingOne_'+index">
        <div class="card-body">
          <ng-container *ngIf="showChildrenContainer(item)">
            <ng-container *ngTemplateOutlet="branch; context: { $implicit : item.children}"></ng-container>
          </ng-container>
        </div>
      </div>
    </div>

  </div>

</ng-template>

<!-- trigger outer node -->
<ng-container *ngTemplateOutlet="branch; context:{ $implicit: treeNodes}">
</ng-container>
